import { action, computed, observable } from 'mobx';
import { useRequest } from 'ahooks';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import NavibarStore from '@src/business-components/navibar/store';
import { semTracker } from '@src/sem-tracker/index';
import { useEffect } from 'react';
import useModal from '@src/utils/hooks/use-modal';
import Video from '@src/components/video';
import AppointmentModalStore from '@src/business-components/appointment-modal/store';
import AppointmentModal from '@src/business-components/appointment-modal';
import FloatRightStore from '@src/business-components/float-right/store';
import FeatureStore from './components/feature/store';
import FollowUsStore from './components/follow-us/store';
import OpenBetaHighlightsStore from './components/open-beta-highlights/store';
import FooterStore from '@src/business-components/footer/store';
import { getOmniData } from '@src/services/omni-api';
import createHtmlLink from '@src/utils/create-html-link';
import AntdMessage from '@src/components/antd/message';
import $$tracker from '@src/tracker';
import { getTranckUrl, getIframeUrl } from '@src/utils/qr-track-iframe';
import lockAsync from '@src/utils/lock-async';

class MainStore extends BaseStore {
  // 导航栏
  navibarStore = new NavibarStore({
    appointment: () => {
      this.showAppointment('顶部通栏');
    }
  });
  // 预约弹窗
  appointmentModalStore = new AppointmentModalStore();
  floatRightStore = new FloatRightStore();
  featureStore = new FeatureStore();
  openBetaHighlightsStore = new OpenBetaHighlightsStore();
  followUsStore = new FollowUsStore({
    showFooter: () => this.showFooter()
  });
  footerStore = new FooterStore({
    closeFooter: () => this.closeFooter()
  });

  @observable subscribe_total = 0;

  @observable stage = 2; // 1-预约阶段 2-预约+下载 3-下载
  //终止时间限制
  @observable maxTime = 90000;
  //定时器时间
  @observable timerTime = 0;
  @observable is_login = 0;
  @observable pc_login_token = '';

  @observable downloadUrl = {};
  @observable game_stage_config = 'beta_download'; // 游戏阶段信息 预约期-appointment 预下载期-pre_download 公测期-beta_download
  @observable kvData = {}; // kv数据

  @observable footerVisible = false;

  @observable indexQrcode = '';

  @computed
  get loginStatus() {
    return !!this.is_login;
  }

  @computed
  get subscribeTotal() {
    return this.subscribe_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * 预约弹窗
   * @returns
   */
  @action.bound
  showAppointment(type) {
    if (type === '顶部通栏') {
      $$tracker.clickGoReservation('顶部通栏');
    } else {
      $$tracker.clickGoReservation('首页按钮');
    }
    // createHtmlLink('weixin://dl/officialaccounts?gh=gh_1f50b9a4700f').click();
    // return;
    this.appointmentModalStore.AppointmentMethod = true;
    this.appointmentModalStore.modalType = 1;
    this.appointmentModalStore.isOpen = true;
    this.modals.appointmentModal.open();
    if (this.appointmentModalStore.AppointmentMethod && !this.loginStatus && this.appointmentModalStore.modalType === 1) {
      this.loopCheckLoginStatus();
      this.loopGetQrCode();
    }
    // 轮询请求，回调方法出来停止轮询
    this.appointmentModalStore.switchSuccess = () => {
      if (this.appointmentModalStore.AppointmentMethod && !this.loginStatus && this.appointmentModalStore.modalType === 1) {
        this.loopGetQrCode();
        this.loopCheckLoginStatus();
      } else {
        clearInterval(this.timer);
        clearInterval(this.timer1);
      }
    };
    this.appointmentModalStore.updataConfig = () => {
      this.getConfigRequest.run();
    };
  }

  /**
   * 循环请求二维码
   */
  loopGetQrCode() {
    this.getQrCodeRequest.run();
    this.timer1 = setInterval(() => {
      if (this.appointmentModalStore.isOpen) {
        this.getQrCodeRequest.run();
      } else {
        clearInterval(this.timer1);
      }
    }, 240000);
  }

  getQrCode() {
    const values = [
      this.getParameterByNames('utm_source'),
      this.getParameterByNames('_btcode'),
      this.getParameterByNames('bd_vid'),
      window.location.href,
      semTracker.deviceId
    ];
    let utm_source = 'pc';
    utm_source += '+' + values.join('+');
    // let utm_source = this.getParameterByNames('utm_source') ? this.getParameterByNames('utm_source') : 'pc';
    return this.$ztService
      .getQrCode(utm_source, DEPLOY_ENV === 'master' ? 'release' : 'trial', 'pages/transitional/index')
      .then(res => {
        const { img, pc_login_token } = res;
        this.appointmentModalStore.qrcodeImg = img;
        this.pc_login_token = pc_login_token;
      })
      .catch(error => {
        const { message, code } = error.serviceResponse;
      });
  }

  /**
   * 循环调用
   */
  loopCheckLoginStatus() {
    this.timer = setInterval(() => {
      if (this.timerTime < this.maxTime && !this.loginStatus) {
        this.timerTime += 3000;
        this.checkPcLoginStatusRequest.run();
      } else {
        clearInterval(this.timer);
      }
    }, 3000);
  }
  /**
   * 清除定时器
   */
  clearTime() {
    this.timerTime = 0;
    clearInterval(this.timer);
  }

  getConfig() {
    return this.$ztService
      .getConfig(0, this.pc_login_token)
      .then(res => {
        const { add_wx_account, add_wx_manager, subscribe_total, invite_count, lottery_time, phone, share_friend, uid, test_download_status } = res;
        this.phone = phone;
        this.subscribe_total = subscribe_total;
        this.appointmentModalStore.phone = phone;
        this.navibarStore.phone = phone;
      })
      .catch(error => {
        const { message, code } = error.serviceResponse;
      });
  }

  /**
   *  同步登录态，检测小程序预约情况
   */
  checkPcLoginStatus() {
    return this.$ztService
      .checkPcLoginStatus(this.pc_login_token)
      .then(res => {
        // "display_phone": "展示手机号",
        // "is_login": "是否已预约（1：已预约，0：未预约）"
        const { display_phone, is_login } = res;
        if (display_phone) {
          this.phone = display_phone;
        }
        this.is_login = is_login;
        if (is_login === 1) {
          this.getConfigRequest.run();
        }
      })
      .catch(error => {
        const { message, code } = error.serviceResponse;
      });
  }

  /**
   * 获取下载数据
   */
  getDownload = async () => {
    const downloadData = await getOmniData('channel_cat_download');
    // sh6egh6rz9xe - 下载组件
    // sh6ehvi2coaq - 游戏阶段信息
    // sh6ekm5lzf2a - 自定义渠道（安卓）
    const { sh6egh6rz9xe, sh6ehvi2coaq, sh6ekm5lzf2a } = downloadData;
    let download = sh6egh6rz9xe?.result?.items;
    // 遍历数组把分类作为key处理成一个对象
    download?.forEach(element => {
      this.downloadUrl[element.download_channel_code] = element.download_link.url || element.channel_qrcode[0]?.url;
    });
    // 判断是带有渠道标识
    const utm_source = this.getParameterByNames('utm_source');
    const utmInfo = sh6ekm5lzf2a?.result?.items;
    if (utm_source) {
      const utmUrl = utmInfo.find(it => it.download_channel_code === 'utm_source' && it.utm_source === utm_source)?.download_link?.url;
      if (utmUrl) {
        this.downloadUrl.android = utmUrl;
        this.downloadUrl.qrcode = utmUrl;
      }
      // PC的下载链接，拼上渠道标识
      this.downloadUrl.pc = this.downloadUrl.pc + '?utm_source=' + utm_source;
    }
    // 设置 二维码链接,初始化中转页面链接-PC用
    if (this.downloadUrl.android) {
      setTimeout(() => {
        const trackDownloadUrlIndex = getTranckUrl(this.downloadUrl.android, {
          eventName: 'scan_download_game',
          eventDescription: '扫码下载',
          eventDataValue: { title: '首页kv下载组件' }
        });
        const indexQrcode = getIframeUrl(trackDownloadUrlIndex);
        console.log('indexQrcode有数据了', indexQrcode);

        // 设置 iframe 二维码中转页的链接
        this.downloadUrl.indexQrcode = indexQrcode;
        this.indexQrcode = indexQrcode;
        console.log('this.indexQrcode', this.indexQrcode);
      }, 200);

      setTimeout(() => {
        const trackDownloadUrlFloat = getTranckUrl(this.downloadUrl.android, {
          eventName: 'scan_download_game',
          eventDescription: '扫码下载',
          eventDataValue: { title: '侧边栏下载组件' }
        });
        const FloatQrcode = getIframeUrl(trackDownloadUrlFloat);
        this.downloadUrl.FloatQrcode = FloatQrcode;
        this.floatRightStore.downloadUrl = this.downloadUrl;
        this.floatRightStore.FloatQrcode = FloatQrcode;
      }, 200);
    }
    // 为浮窗位置赋值
    this.floatRightStore.downloadUrl = this.downloadUrl;

    // 获取游戏阶段信息
    if (sh6ehvi2coaq?.result?.items?.[0]) {
      this.game_stage_config = sh6ehvi2coaq.result?.items?.[0]?.game_stage_config || '';
      // 添加一个标识：模拟下载阶段
      // const MOCKDOWNLOAD = this.getParameterByNames('MOCKDOWNLOAD');
      // if (MOCKDOWNLOAD === '1') {
      //   this.game_stage_config = 'pre_download';
      // } else if (MOCKDOWNLOAD === '2') {
      //   this.game_stage_config = 'beta_download';
      // }
      this.navibarStore.game_stage_config = this.game_stage_config;
      if (this.game_stage_config === 'beta_download' || this.game_stage_config === 'pre_download') {
        this.floatRightStore.type = 1;
      } else {
        this.floatRightStore.type = 2;
      }
    }
  };

  /**
   * 点击下载
   * @param {*} type
   */
  handleDownload = type => {
    if (type === 'android') {
      $$tracker.clickDownloadAndroid('首页kv下载组件');
    } else if (type === 'apple') {
      $$tracker.clickDownloadIOS('首页kv下载组件');
    } else if (type === 'pc') {
      $$tracker.clickDownloadPC('首页kv下载组件');
    } else if (type === 'charge') {
      $$tracker.clickGoRecharge();
    }
    if (this.downloadUrl[type]) {
      let link = createHtmlLink(this.downloadUrl[type]);
      link.target = '_blank';
      link.click();
    } else {
      AntdMessage.error('链接不存在');
    }
  };

  /**
   * 获取游戏特色数据
   */
  getFeatureData = async () => {
    // 游戏特色
    const featureData = await getOmniData('channel_cat_feature_fab');
    // featureData
    let featureArr = [];
    if (featureData.sh6e8b7673lu.result?.items) {
      featureData.sh6e8b7673lu.result?.items.forEach(element => {
        if (element.rotating_chart?.[0]?.url) {
          featureArr.push(element.rotating_chart?.[0]?.url);
        }
      });
    }
    // 赋值
    this.featureStore.featureData = featureArr;
  };

  /**
   * 获取首屏KV数据
   */
  getKvData = async () => {
    // 首屏KV
    const kv = await getOmniData('channel_cat_kv');
    const kvData = kv.sh6elqlqsjk2?.result?.items?.[0] || {};
    if (kvData) {
      this.kvData = {
        kv_image: kvData.kv_image?.[0]?.url,
        kv_pv_video: kvData.kv_pv_video?.[0]?.url,
        kv_video: kvData.kv_video?.[0]?.url
      };
    }
  };

  /**
   * 点击播放视频
   * @returns
   */
  @lockAsync()
  openVideo = () => {
    if (!this.kvData.kv_pv_video) {
      AntdMessage.error('视频不存在');
      return;
    }
    Video.append({ src: this.kvData.kv_pv_video });
  };

  /**
   * 获取公测亮点数据
   */
  getHighlightData = async () => {
    // 公测亮点
    const highlightData = await getOmniData('channel_cat_highlight');
    // 处理最新数据 swiper
    const highlightSwiper = [];
    if (highlightData.sh6emq4atj42?.result?.items) {
      highlightData.sh6emq4atj42?.result?.items.forEach(element => {
        if (element.silder?.[0]?.url) {
          highlightSwiper.push(element.silder?.[0]?.url);
        }
      });
    }
    this.openBetaHighlightsStore.swiperData = highlightSwiper;
    this.openBetaHighlightsStore.updateSwiper();

    if (highlightData.sh7t47g6x2bm?.result?.items?.[0]) {
      this.openBetaHighlightsStore.prize_code = highlightData.sh7t47g6x2bm.result?.items?.[0]?.gift_pack_cdkey;
      const {
        icon_title_1,
        icon_title_2,
        icon_title_3,
        icon_title_4,
        icon_title_5,
        prop_icon_1,
        prop_icon_2,
        prop_icon_3,
        prop_icon_4,
        prop_icon_5
      } = highlightData.sh7t47g6x2bm?.result?.items?.[0];
      if (icon_title_1 && prop_icon_1[0]) {
        this.openBetaHighlightsStore.prizeList.push({
          title: icon_title_1,
          img: prop_icon_1[0].url
        });
      }
      if (icon_title_2 && prop_icon_2[0]) {
        this.openBetaHighlightsStore.prizeList.push({
          title: icon_title_2,
          img: prop_icon_2[0].url
        });
      }
      if (icon_title_3 && prop_icon_3[0]) {
        this.openBetaHighlightsStore.prizeList.push({
          title: icon_title_3,
          img: prop_icon_3[0].url
        });
      }
      if (icon_title_4 && prop_icon_4[0]) {
        this.openBetaHighlightsStore.prizeList.push({
          title: icon_title_4,
          img: prop_icon_4[0].url
        });
      }
      if (icon_title_5 && prop_icon_5[0]) {
        this.openBetaHighlightsStore.prizeList.push({
          title: icon_title_5,
          img: prop_icon_5[0].url
        });
      }
    }
  };

  /**
   * 获取cms数据
   */
  getOmniData = () => {
    // 下载组件
    this.getDownload();
    // 首屏KV
    this.getKvData();
    // 公测亮点
    this.getHighlightData();
    // 特色图
    this.getFeatureData();
  };

  showFooter = () => {
    this.footerVisible = true;
    document.body.style.overflow = 'hidden';
  };
  closeFooter = () => {
    this.footerVisible = false;
    document.body.style.overflow = 'auto';
  };
  use() {
    super.use();
    this.getConfigRequest = useRequest(async () => await this.getConfig());
    this.getQrCodeRequest = useRequest(async () => await this.getQrCode(), { manual: true });
    // 同步登录态接口
    this.checkPcLoginStatusRequest = useRequest(async () => await this.checkPcLoginStatus(), { manual: true });

    this.modals = {
      appointmentModal: useModal(AppointmentModal, { store: this.appointmentModalStore })
    };

    useMount(async () => {
      console.log('componentDidMount');
      this.getOmniData();
      // this.showAppointment();
      // this.getConfigRequest.run();
    });
    useEffect(
      () => {
        if (this.appointmentModalStore.modalType === 2) {
          this.loopCheckLoginStatus();
          this.loopGetQrCode();
        } else {
          this.clearTime();
          clearInterval(this.timer1);
        }
      },
      [this.appointmentModalStore.modalType]
    );
  }
}

export default MainStore;
